<app-page-heading [key]="'log-events.list.page-title'"
                  [carriers]="carriers" (selectedCarrierChange)="selectedCarrierChanged($event)">
</app-page-heading>


<section class="container-fluid summary-panel">

    <app-data-table [columns]="columns" [sortColumn]="sortColumn" [loadPage]="loadPage" (beforeReset)="beforeReset()" (onReset)="onReset()" [(filters)]="filters"
                    (onColumnSelected)="columnSelected()" [headSticky]="true" [loadOnReset]="false" [disableSearch]="disableSearch()"
                    [filtersComponent]="dataFilters" [loadAtStartup]="searchOnNavigate" (onLoad)="pageLoaded()">
        <app-data-filters #dataFilters
                          [fullWidth]="true"
                          [opened]="true"
                          [disableSearch]="disableSearch()"
                          [helper]="(!emptyNonIdentityFilter() && emptyDateFilter())"
                          [helperKey]="'log-events.filters.helper'"
                          [helperColor]="'red'"
                          [helperSide]="HelperPosition.RIGHT">
            <app-data-filter-group [fieldset]="true"
                                   [fieldsetLegendKey]="'log-events.list.filters.help'"
                                   [useAvailableWidth]="true">
                <app-data-filter-autocomplete [labelKey]="'log-events.list.filters.event.label'" [name]="'event'" [multiple]="true"
                                              [(model)]="selectedEventsOptions" [options]="eventsOptions" (modelChange)="selectedEventsChanged()"
                                              [placeholderKey]="'log-events.list.filters.event.placeholder'">
                </app-data-filter-autocomplete>

                <app-data-filter-input [labelKey]="'log-events.list.filters.vehicle.label'" [(model)]="filters.vehicle"
                                       [placeholderKey]="'log-events.list.filters.vehicle.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'log-events.list.filters.location-ref.label'" [(model)]="filters.locationRef"
                                       [placeholderKey]="'log-events.list.filters.location-ref.placeholder'"></app-data-filter-input>

                <app-data-filter-multi-string-input [labelKey]="'log-events.list.filters.load-id.label'"
                                                    [(model)]="filters.loadIds"
                                                    [placeholderKey]="'log-events.list.filters.load-id.placeholder'">
                </app-data-filter-multi-string-input>

                <app-data-filter-multi-string-input [labelKey]="'log-events.list.filters.load-number.label'"
                                                    [(model)]="filters.loadNumbers"
                                                    [placeholderKey]="'log-events.list.filters.load-number.placeholder'">
                </app-data-filter-multi-string-input>

                <app-data-filter-multi-string-input [labelKey]="'log-events.list.filters.delivery-number.label'"
                                                    [(model)]="filters.shipmentNumbers"
                                                    [placeholderKey]="'log-events.list.filters.delivery-number.placeholder'">
                </app-data-filter-multi-string-input>
            </app-data-filter-group>
            <app-data-filter-group class="advanced-search-filters" [useAvailableWidth]="true">
                    <app-data-filter-input [labelKey]="'log-events.list.filters.user-email.label'" [(model)]="filters.userEmail"
                                           [placeholderKey]="'log-events.list.filters.user-email.placeholder'"></app-data-filter-input>

                    <app-data-filter-input [labelKey]="'log-events.list.filters.consumer-version.label'" [(model)]="filters.consumerVersion"
                                           [placeholderKey]="'log-events.list.filters.consumer-version.placeholder'"></app-data-filter-input>

                    <app-data-filter-input [labelKey]="'log-events.list.filters.load-uuid.label'" [(model)]="filters.loadUuid"
                                           [placeholderKey]="'log-events.list.filters.load-uuid.placeholder'"></app-data-filter-input>

                    <app-data-filter-input [labelKey]="'log-events.list.filters.stop-id.label'" [(model)]="filters.stopId"
                                           [placeholderKey]="'log-events.list.filters.stop-id.placeholder'"></app-data-filter-input>

                    <app-data-filter-select [labelKey]="'log-events.list.filters.status.label'" [(model)]="filters.status"
                                            [options]="statusOptions" [useOptionLabel]="true"></app-data-filter-select>

                    <app-data-filter-date [labelKey]="'log-events.list.filters.start-date.label'"
                                          [(model)]="startDate"
                                          [maxDate]="endDate"
                                          [minDate]="minDate"
                                          [placeholderKey]="'log-events.list.filters.start-date.placeholder'"
                                          (modelChange)="updateStartDateFilter()">
                    </app-data-filter-date>

                    <app-data-filter-date [labelKey]="'log-events.list.filters.end.label'"
                                          [(model)]="endDate"
                                          [minDate]="startDate"
                                          [maxDate]="maxDate"
                                          [placeholderKey]="'log-events.list.filters.end.placeholder'"
                                          (modelChange)="updateEndDateFilter()">
                    </app-data-filter-date>
                </app-data-filter-group>
            <app-data-filters-button [labelKey]="'log-events.list.filters.export'" [type]="'primary'"
                          (onClick)="openConfirmExportLogEvents(exportLogEventsModal)">
						  <i class="fa fa-download"></i>
            </app-data-filters-button>
        </app-data-filters>
    </app-data-table>

</section>

<ng-template #exportLogEventsModal>
    <span [i18n]="[{target: 'innerHTML', key: 'log-events.modals.export.body'}]"></span>
</ng-template>


<ng-template #typeColumn let-type="type">
    <span class="label" [ngClass]="{ 'label-primary': type === LogEventType.LOG, 'label-danger' : type === LogEventType.ERROR }">
        {{type}}
    </span>
</ng-template>

<ng-template #eventColumn let-item="item">
    <span [i18n]="[{target: 'innerHTML', key: 'log-events.events.' + item.event}]"></span>
</ng-template>

<ng-template #sourceColumn let-source="source">
    {{source}}
</ng-template>

<ng-template #userEmailColumn let-userEmail="userEmail">
    {{userEmail}}
</ng-template>

<ng-template #vehicleColumn let-vehicle="vehicle">
    {{vehicle}}
</ng-template>

<ng-template #carrierNameColumn let-carrierName="carrierName">
    <a class="cmaweb-link" [href]="link.goToCarrierName(carrierName, false)" target="_blank">{{carrierName}}</a>
</ng-template>

<ng-template #loadIdColumn let-loadId="loadId">
    {{loadId}}
</ng-template>

<ng-template #loadUuidColumn let-loadUuid="loadUuid">
    {{loadUuid}}
</ng-template>

<ng-template #loadNumberColumn let-loadNumber="loadNumber">
    <a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(loadNumber)" target="_blank">{{loadNumber}}</a>
</ng-template>

<ng-template #stopIdColumn let-stopId="stopId">
    {{stopId}}
</ng-template>

<ng-template #shipmentNumberColumn let-shipmentNumber="shipmentNumber">
    <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(shipmentNumber)" target="_blank">{{shipmentNumber}}</a>
</ng-template>

<ng-template #locationRefColumn let-locationRef="locationRef">
    <a class="cmaweb-link" [href]="link.goToLocationGlid(locationRef)" target="_blank">{{locationRef}}</a>
</ng-template>

<ng-template #consumerVersionColumn let-consumerVersion="consumerVersion">
    {{consumerVersion}}
</ng-template>

<ng-template #createdAtColumn let-createdAt="createdAt">
    {{createdAt | fullDate}}
</ng-template>

<ng-template #statusColumn let-status="status">
    <span class="label" [ngClass]="{ 'label-success': status === LogEventStatus.SUCCEED, 'label-warning' : status === LogEventStatus.PARTIALLY_SUCCEED, 'label-danger' : status === LogEventStatus.FAILED }">
        {{status}}
    </span>
</ng-template>

<ng-template #contextualDataColumn let-item="item">
    <pre>{{item.contextualData}}</pre>
</ng-template>

<ng-template #contextualDataActionsColumn let-item="item">
    <button class="btn btn-primary btn-sm m-r-sm" (click)="openContextualData(item)">
        <i class="fa fa-external-link-alt"></i>
    </button>
    <button class="btn btn-default btn-sm" (click)="copyJson(item.contextualData)" [i18n]="[{target: 'attribute:title', key: 'copy.tooltip'}]">
        <i class="fa fa-copy"></i>
    </button>
</ng-template>

<ng-template #resultBodyColumn let-item="item">
    <pre>{{item.resultBody}}</pre>
</ng-template>

<ng-template #resultBodyActionsColumn let-item="item">
    <button class="btn btn-primary btn-sm m-r-sm" (click)="openResult(item)">
        <i class="fa fa-external-link-alt"></i>
    </button>
    <button *ngIf="item.resultBody" class="btn btn-default btn-sm" (click)="copyJson(item.resultBody)" [i18n]="[{target: 'attribute:title', key: 'copy.tooltip'}]">
        <i class="fa fa-copy"></i>
    </button>
</ng-template>
